var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVault = function SvgVault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vault_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__b)",
    d: "M0 22.5C0 12.747 0 7.87 2.646 4.555a12 12 0 0 1 1.91-1.909C7.87 0 12.745 0 22.5 0s14.63 0 17.945 2.646a12 12 0 0 1 1.909 1.91C45 7.87 45 12.745 45 22.5s0 14.63-2.646 17.945a12 12 0 0 1-1.91 1.909C37.13 45 32.255 45 22.5 45S7.87 45 4.555 42.354a12 12 0 0 1-1.909-1.91C0 37.13 0 32.255 0 22.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__c)",
    d: "M28.52 19.296q.749-10.527-5.406-10.527t-5.406 10.527h-2.96Q13.59 5.704 23.114 5.704t8.366 13.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F3292",
    d: "m14.577 33.136-.064-.067-.127-.135-.063-.067-.125-.135c-1.015-1.108-1.886-2.318-2.067-4.904q-.085-1.2-.089-3.405v-.484q.004-2.311.089-5.628l10.982-2.523 10.983 2.523q.085 3.316.089 5.628v.484q-.004 2.205-.089 3.405c-.181 2.586-1.052 3.796-2.067 4.904l-.125.135-.063.067-.127.135-.064.067q-2.299 2.428-8.536 4.902-6.24-2.474-8.537-4.902"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__d)",
    d: "M28.489 14.802q-.105-6.138-5.387-6.138t-5.363 6.138q.903-5.454 5.363-5.454 4.462 0 5.386 5.454"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__e)",
    d: "m14.577 32.282-.194-.196-.128-.13c-1.04-1.07-1.94-2.217-2.125-4.721q-.084-1.14-.088-3.23v-.476q.005-2.196.088-5.342l10.983-2.399 10.983 2.399q.085 3.147.089 5.342v.477q-.004 2.09-.089 3.229c-.184 2.504-1.085 3.651-2.124 4.72l-.128.131-.194.196q-2.299 2.308-8.536 4.66-6.24-2.352-8.537-4.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__f)",
    d: "m23.113 15.788 10.983 2.399q.178 6.642 0 9.048c-.204 2.76-1.276 3.871-2.446 5.047q-2.298 2.308-8.537 4.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__g)",
    d: "M23.06 15.788v1.756l-11.018 2.264.031-1.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#vault_svg__h)",
    d: "M23.113 15.788v1.751l11.022 2.268-.036-1.622z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__b",
    x1: 45,
    x2: 0,
    y1: 0,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C66F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__c",
    x1: 14.578,
    x2: 8.298,
    y1: -55.141,
    y2: 26.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#FBF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__d",
    x1: 555.203,
    x2: 555.203,
    y1: -52.882,
    y2: 70.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__e",
    x1: 12.993,
    x2: 22.817,
    y1: 14.578,
    y2: 35.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__f",
    x1: 422.094,
    x2: 1174.71,
    y1: 2131.18,
    y2: 1314.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B27EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B482FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__g",
    x1: 12.042,
    x2: 562.984,
    y1: 184.904,
    y2: 184.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__h",
    x1: 34.135,
    x2: -1035.32,
    y1: 232.121,
    y2: 30.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE92FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vault_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v45H0z"
  })))));
};
export default SvgVault;